export default __webpack_public_path__ + "static/media/CSIO_CommercialLine_WorkingGroup.1a92f7c3.pdf";